module.exports = __webpack_public_path__ + "4e63d02b9b559054cc8853449e9920e0.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
 ** module id = 2016
 ** module chunks = 73
 **/